import styles from "@/components/toolTip/Tooltip.module.scss";
import {TooltipVariant, useTooltipContext} from "@/components/toolTip/Tooltip.tsx";
import {FloatingArrow, FloatingPortal, useMergeRefs} from "@floating-ui/react";
import classNames from "classnames";
import {forwardRef, HTMLProps} from "react";

interface TooltipContentProps extends HTMLProps<HTMLDivElement> {
  variant?: TooltipVariant;
}

export const TooltipContent = forwardRef<HTMLDivElement, TooltipContentProps>(function TooltipContent(
  {style, children, className, variant = "dark", ...props},
  propRef
) {
  const context = useTooltipContext();
  const ref = useMergeRefs([context.refs.setFloating, propRef]);

  if (!context.open) return null;

  return (
    <FloatingPortal>
      <div
        ref={ref}
        style={{
          ...context.floatingStyles,
          ...style,
        }}
        className={classNames(styles[variant], context.onModal ? styles.onModal : styles.default, className)}
        {...context.getFloatingProps(props)}
      >
        {context.showArrow !== false && (
          <FloatingArrow
            ref={context.arrowRef}
            context={context.context}
            width={14}
            fill={variant === "light" ? "#ffffff" : undefined}
            stroke={variant === "light" ? "#ced0d1" : undefined}
            strokeWidth={variant === "light" ? 1 : 0}
          />
        )}
        {children}
      </div>
    </FloatingPortal>
  );
});
